import { Controller } from "@hotwired/stimulus"

// Turbo Stream後にターゲット要素にスクロールするワンショットコントローラー
// 使い方: <div data-controller="scroll-to" data-scroll-to-target-id-value="menu_item_59"></div>
export default class extends Controller {
  static values = { targetId: String }

  connect() {
    // ツリー内の画像ロード完了を待ってからスクロール（レイアウトシフト防止）
    const tree = document.getElementById("menu-category-tree")
    if (tree) {
      const imgs = Array.from(tree.querySelectorAll("img"))
      const unloaded = imgs.filter(img => !img.complete)
      if (unloaded.length > 0) {
        let done = false
        const doScroll = () => {
          if (done) return
          done = true
          this._scrollToTarget()
        }
        Promise.allSettled(
          unloaded.map(img => new Promise(r => {
            img.addEventListener("load", r, { once: true })
            img.addEventListener("error", r, { once: true })
          }))
        ).then(doScroll)
        // フォールバック: 3秒で強制スクロール
        setTimeout(doScroll, 3000)
        return
      }
    }
    // 画像が全てロード済みの場合
    requestAnimationFrame(() => this._scrollToTarget())
  }

  _scrollToTarget() {
    const el = document.getElementById(this.targetIdValue)
    if (!el) {
      this.element.remove()
      return
    }

    // 閉じたカテゴリの中にあるなら、先に開いてもらう（menu-list が受け取る）
    const collapsed = el.closest("[data-collapse-content].hidden")
    const categoryId = collapsed?.closest("[data-category-id]")?.dataset.categoryId
    if (categoryId) {
      this.element.dispatchEvent(new CustomEvent("menu-list:expand", { bubbles: true, detail: { categoryId } }))
    }

    el.scrollIntoView({ behavior: "smooth", block: "center" })

    // スクロールと並行してハイライトアニメーションを即座に開始
    const highlightEl = el.firstElementChild || el
    highlightEl.classList.add("animate-highlight")
    highlightEl.addEventListener("animationend", () => {
      highlightEl.classList.remove("animate-highlight")
    }, { once: true })

    // レイアウトシフト補正: 500ms後にずれていたら再スクロール
    setTimeout(() => {
      const rect = el.getBoundingClientRect()
      const centerOffset = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2)
      if (centerOffset > 100) {
        el.scrollIntoView({ behavior: "smooth", block: "center" })
      }
      this.element.remove()
    }, 500)
  }
}
